
export const HOOKS_DEEP_DIVE_CODE_EXAMPLES = [
  {
    title: "Custom Data Fetching Hook",
    code: `function useApi(url) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(url);
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { data, loading, error };
}`,
    explanation: "Custom hook for API data fetching with loading and error states",
    language: "jsx"
  }
];
